import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Auth0LoginButton, buildAuth0PopupUrl, useAuth } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `LoginComponent`/`UserLoginComponent` (audit §3/§5).
// 2026-09-26 (owner decision, legacy-migration/RULES.md): password-based
// login and the direct-Google popup both moved to Auth0's Universal Login —
// this page is now just the entry point into that flow, via the SAME
// popup+postMessage handoff `GoogleLoginButton` used (origin-checked in
// `Auth0LoginButton` itself — nothing page-specific to fix here).
//
// 2026-09-27 LIVE BUG FIX: a successful popup login stored the token and
// resolved `refresh()`, but nothing navigated away from /login — the page
// kept rendering the signed-out view until a manual reload or URL change.
// `onSuccess` (below) and the already-authenticated redirect close that gap.
export function LoginPage() {
  const navigate = useNavigate()
  const { status } = useAuth()

  // Visiting /login while already signed in (e.g. a stale tab, or the popup
  // flow's own message racing a manual reload) goes straight to the app
  // instead of showing a "sign in" screen for an already-signed-in user.
  useEffect(() => {
    if (status === 'authenticated') navigate(POST_LOGIN_PATH, { replace: true })
  }, [status, navigate])

  const goToApp = () => navigate(POST_LOGIN_PATH, { replace: true })

  return (
    <div className="screener-card screener-card--auth">
      <h1>Sign in</h1>
      <p>
        <Auth0LoginButton popupUrl={AUTH0_LOGIN_URL} expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN} onSuccess={goToApp}>
          Log in
        </Auth0LoginButton>
      </p>
      <p>
        <Auth0LoginButton
          popupUrl={buildAuth0PopupUrl(AUTH0_LOGIN_URL, { connection: 'google-oauth2' })}
          expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
          onSuccess={goToApp}
        >
          Continue with Google
        </Auth0LoginButton>
      </p>
      <p>
        Forgotten your password, or confirming an old e-mail link?{' '}
        <Link to="/password-forgot">See here</Link>.
      </p>
      <p>
        No account yet? <Link to="/register">Register</Link>
      </p>
    </div>
  )
}
